import React, { Fragment, Component } from 'react';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import Axios from 'axios';



class ThirdCarousel extends Component {
    
    state = {
        data: [{
            data: [
                {
                    mock: [
                        {
                           imgLink: "./images/thumbnail-chair-secondary.png",
                           imgCaption: "Comfy Dining Chair 1",
                            saleprice: "$89.80",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
    
    
                        },
                        {
                           imgLink: "./images/thumbnail-relax-chair-secondary.png",
                           imgCaption: "Red Chair",
                            saleprice: "$89.80",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
                        },
                        {
                           imgLink: "./images/thumbnail-chair-secondary.png",
                           imgCaption: "Blue Chair",
                            saleprice: "$89.80",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
                        },
                        {
                           imgLink: "./images/thumbnail-relax-chair-secondary.png",
                           imgCaption: "Red Chair",
                            saleprice: "$89.80",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
                        }
                    ]
                },
                {
                    mock: [
                        {
                           imgLink: "./images/thumbnail-chair-secondary.png",
                           imgCaption: "Blue Chair",
                            saleprice: "",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
                        },
                        {
                           imgLink: "./images/thumbnail-relax-chair-secondary.png",
                           imgCaption: "Red Chair",
                            saleprice: "",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
                        },
                        {
                           imgLink: "./images/thumbnail-chair-secondary.png",
                           imgCaption: "Blue Chair",
                            saleprice: "$89.80",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
                        },
                        {
                           imgLink: "./images/thumbnail-relax-chair-secondary.png",
                           imgCaption: "Red Chair",
                            saleprice: "",
                            orginalprice: "$124.00",
                            discountpercentage: "80%"
                        }
                    ]
                }
            ]
        }]
    }
    constructor(props) {
        super(props)


    }
    componentDidMount() {
        // Axios.get('http://localhost:3000/data/thirdCarousel.json')
        //     .then(response => {
        //         console.log(response.data.data)
        // this.setState({ data: dataMock })
        console.log(this.state.data)
        // })
        // .catch(error => {
        //     console.log(error)
        // })
    }


    render() {
        const { data } = this.state

        return (
            <Carousel>
                {data[0].data.map((data, i) => (
                    <Carousel.Item key={i}>
                        <Row className="justify-content-between">
                            {data.mock.map((data, i) => (

                                <Col md={3} key={i} className="text-center mb-3">
                                    <img
                                        className="d-block w-100 secondary-carousel-image ml-auto mr-auto"
                                        src={data.imgLink}
                                        alt="First slide"
                                    />
                                    <h5>{data.imgCaption + i}</h5>
                                    {data.saleprice != "" ?
                                        <Fragment>
                                            <p className="sale-price">{data.saleprice}</p>
                                            <p><s>{data.orginalprice}</s></p>
                                        </Fragment>
                                        :
                                        <p>{data.orginalprice}</p>
                                    }
                                </Col>


                            ))}

                        </Row>


                    </Carousel.Item>
                ))}



            </Carousel>
        )

    }

}
export default ThirdCarousel